import { createContext, ReactNode, useContext } from 'react';
import { playSound, PlaySoundOptions, SoundName, stopSound } from './play-sound';

export type PlaySoundContextType = {
    playSound: (soundName: SoundName, options?: PlaySoundOptions) => void;
    stopSound: (soundName: SoundName) => void;
};

const PlaySoundContext = createContext<PlaySoundContextType | undefined>(undefined);

const defaultValue = {
    playSound,
    stopSound,
};

export function PlaySoundProvider({
    value,
    children,
}: {
    value?: Partial<PlaySoundContextType>;
    children: ReactNode;
}) {
    const finalValue = { ...defaultValue, ...value };
    return <PlaySoundContext.Provider value={finalValue}>{children}</PlaySoundContext.Provider>;
}

export function usePlaySound(): PlaySoundContextType {
    const value = useContext(PlaySoundContext);
    if (!value) {
        throw new Error('Unexpectedly did not find PlaySoundContext value');
    }
    return value;
}
